<app-hero (joinClick)="openJoin()" />
<app-about />
<app-offerings (joinClick)="openJoin($event)" />
<app-gallery />
<app-faq />
<app-info />
<app-slogan (joinClick)="openJoin()" />
<app-footer />
